// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "-legacy." + {"284":"c0ce34f0","501":"fbe7b080","785":"f3e4bc65","816":"560c44da"}[chunkId] + ".js"; };